import * as ko from "knockout";

export class AddressBookSearchCriteria {
  generalSearch: KnockoutObservable<string>;
  id: KnockoutObservable<string>;
  cf0: KnockoutObservable<string>; // partner id
  cf1: KnockoutObservable<string>; // customer name
  cf2: KnockoutObservable<string>; // customer address
  cf3: KnockoutObservable<string>; // customer zip
  cf4: KnockoutObservable<string>; // km
  cf5: KnockoutObservable<string>; // timestamp change
  sort_dir: KnockoutObservable<string>;
  sort_field: KnockoutObservable<string>;
  Page: KnockoutObservable<number>;
  Rows: KnockoutObservable<number>;
  page_dir: KnockoutObservable<string>;

  constructor(item) {
    this.generalSearch = ko.observable(item.generalSearch);
    this.id = ko.observable(item.id);
    this.cf0 = ko.observable(item.cf0);
    this.cf1 = ko.observable(item.cf1);
    this.cf2 = ko.observable(item.cf2);
    this.cf3 = ko.observable(item.cf3);
    this.cf4 = ko.observable(item.cf4);
    this.cf5 = ko.observable(item.cf5);
    this.sort_dir = ko.observable(item.sort_dir);
    this.sort_field = ko.observable(item.sort_field);
    this.Page = ko.observable(item.Page || 0);
    this.Rows = ko.observable(item.Rows || 15);
    this.page_dir = ko.observable(item.page_dir);
  }
}
